// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/loginbg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.static {
  position: static;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.-left-\\[12px\\] {
  left: -12px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-\\[69px\\] {
  left: 69px;
}
.top-1 {
  top: 0.25rem;
}
.top-\\[8px\\] {
  top: 8px;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.m-0 {
  margin: 0px;
}
.my-\\[1\\.5rem\\] {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-\\[4px\\] {
  margin-bottom: 4px;
}
.me-4 {
  margin-inline-end: 1rem;
}
.me-5 {
  margin-inline-end: 1.25rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-5 {
  margin-inline-start: 1.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-\\[0\\.2rem\\] {
  margin-top: 0.2rem;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.hidden {
  display: none;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[4px\\] {
  height: 4px;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-screen {
  height: 100vh;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-\\[6px\\] {
  gap: 6px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-full {
  border-radius: 9999px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[\\#B5B5B6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(181 181 182 / var(--tw-border-opacity));
}
.border-\\[\\#E6E6E6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity));
}
.bg-\\[\\#B5B5B6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(181 181 182 / var(--tw-bg-opacity));
}
.bg-\\[\\#F2F2F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#f2f2f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#FF3E5B\\] {
  --tw-gradient-from: #FF3E5B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 62 91 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#FFE1D8\\] {
  --tw-gradient-to: #FFE1D8 var(--tw-gradient-to-position);
}
.object-contain {
  object-fit: contain;
}
.p-5 {
  padding: 1.25rem;
}
.p-\\[3px\\] {
  padding: 3px;
}
.p-\\[4px\\] {
  padding: 4px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[40px\\] {
  padding-left: 40px;
  padding-right: 40px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.pb-\\[8px\\] {
  padding-bottom: 8px;
}
.pl-\\[16px\\] {
  padding-left: 16px;
}
.pl-\\[20px\\] {
  padding-left: 20px;
}
.pl-\\[21px\\] {
  padding-left: 21px;
}
.pl-\\[26px\\] {
  padding-left: 26px;
}
.pl-\\[30px\\] {
  padding-left: 30px;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.pr-\\[14px\\] {
  padding-right: 14px;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.capitalize {
  text-transform: capitalize;
}
.text-\\[\\#342C2C\\] {
  --tw-text-opacity: 1;
  color: rgb(52 44 44 / var(--tw-text-opacity));
}
.text-\\[\\#FF3E5B\\] {
  --tw-text-opacity: 1;
  color: rgb(255 62 91 / var(--tw-text-opacity));
}
.text-\\[\\#ff3e5b\\] {
  --tw-text-opacity: 1;
  color: rgb(255 62 91 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.shadow-\\[0_0_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 0 3px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_1px_1px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\] {
  --tw-shadow: 0px 1px 1px 0px rgba(0,0,0,0.15);
  --tw-shadow-colored: 0px 1px 1px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}

body {
  margin: 0;
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.hover\\:bg-white:hover {
  background-color: transparent !important;
}


#navbars::-webkit-scrollbar,
#overFlowNone::-webkit-scrollbar {
  display: none;
  --webkit-scrollbar-width: none;
  -ms-scrollbar-width: none;
  /* IE and Edge */
  scrollbar-width: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

input:focus-visible,
input {
  border: none;
  outline: none;
}

button {
  border: none;
  outline: none;
}

#right-to-left {
  animation: rightToLeft 0.7s linear;
  right: 5px;
}

@keyframes rightToLeft {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0%);
  }
}

#left-to-right {
  right: -400px;
  animation: leftToRight 0.7s linear;
  transition: right 0.7s ease-in-out !important;
}

@keyframes leftToRight {
  from {
    transform: translateX(0%);
  }

  to {
    transform: translateX(100%);
  }
}

/* smooth sidebar slide */

#isOpenNavbar {
  width: 60px;
  transition: width 0.3s cubic-bezier(0.46, 0.03, 0.52, 0.96);
}

#isOpenNavbar.isOpenNavbar {
  width: 282px;
  transition: width 0.3s cubic-bezier(0.46, 0.03, 0.52, 0.96);
}








/* Start Login Page CSS */
.parent-div {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.login-button {
  border: none;
  outline: none;
  background: #4f52b2;
  border-radius: 5.03061px;
  color: #fff;
  padding: 10px;
  font-size: 14px;
}

.welcome-arrow h3 {
  color: #2f2f2f;
  font-weight: 600;
  font-size: 2rem;
}

.bottom-img1 {
  /* background-image: url("../../../../../assets/left-cloud.png"); */
  background-repeat: no-repeat;
  background-position: bottom left;
  height: 19vh;
  background-size: contain;
}

.bottom-img2 {
  /* background-image: url("../../../../../assets/right-cloud.png"); */
  background-repeat: no-repeat;
  background-position: bottom right;
  height: 19vh;
  background-size: contain;
}

.links-div {
  height: 86vh;
  position: relative;
  border-bottom: 1px solid #ddd;
}

.bottom-link {
  position: absolute;
  bottom: 0;
  margin-bottom: 1rem;
}

.manage-text {
  color: #9198a0;
  padding: 0rem 5rem;
  margin-bottom: 1rem;
}

.p-5 {
  padding: 3rem !important;
}

.welcome-div {
  background: #FFFFFF;
  border: 1px solid rgba(219, 213, 253, 0.4);
  border-radius: 8px;
  width: 40%;
  padding-bottom: 23px;
  box-shadow: 0px 6px 20px 0px #25242414;
  transition: all 0.5s ease;
}

.bottom-cloud {
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 10vh;
  /* background-image: url("../../../../../assets/bottom-combined-cloud.png"); */
  background-repeat: no-repeat;
  background-size: cover;
}

.login-button {
  border: none;
  outline: none;
  background: #4f52b2;
  border-radius: 5.03061px;
  color: #fff;
  padding: 10px;
  font-size: 14px;
  padding-right: 30px;
}

.ms-3 {
  margin-left: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.logClassHome {
  display: flex;
  justify-content: center;
}

img.img-fluid {
  display: inline-block;
}

/* End Login Page CSS */




/* Site Map pages */

.dashboard-parent {
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - 90px);
  overflow: auto;
  padding-left: 12px;
}

.cards-content-div {
  width: 100%;
  /* margin-top: 5rem; */
  padding: 10px 0px;
  height: auto;
  /* border-top: 1.3px solid #e6e6e6; */
}

h6.title {
  color: #FF3E5B;
  font-weight: 500;
  font-size: 1rem;
  padding: 5px 8px;
}

p.data {
  margin: 0;
  color: #0B0B0C;
  padding: 5px 8px;
  font-size: 0.9rem;
}

.bd-bottom {
  border-bottom: 1.3px solid #e6e6e6;
  margin: 20px 10px;
}

.afterDisable:after {
  content: none !important;
}

.catClass {
  color: #FF3E5B !important ;
}
.cat_name_subData{
  color:  black !important;
  /* b4/14_regular */
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px; /* 164.286% */
  padding-left: 10px;
}




/* Logout popup */


.button-div {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
}

.modal-footer {
  border-top: none !important;
  justify-content: start !important;
  flex-wrap: nowrap !important;
}

.btn-style {
  border: none;
  outline: none;
  background-color: none;
  padding: 0.5rem;
  border-radius: 4px;
}

.no-btn {
  border-radius: 0.25rem;
  border: 1px solid var(--lightmode-primary-red, #FF3E5B);
  color: var(--lightmode-primary-red, #FF3E5B);
  text-align: center;
  background-color: #fff;
}

p.logout-text {
  font-size: 1.1rem;
  font-weight: 600;
}

.yes-btn {
  border-radius: 0.25rem;
  background: var(--lightmode-primary-red, #FF3E5B);
  border: 1px solid var(--lightmode-primary-red, #FF3E5B);
  color: #fff;
  text-align: center;
}


/* loader css */
.loader-screen {
  display: block;
  position: fixed;
  display: flex;
  z-index: 999;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader-text{
  width: 30%;
}
@keyframes rotation {
  0% {
      transform: rotate(0deg);
  }

  100% {
      transform: rotate(360deg);
  }
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:-left-\\[14px\\]::after {
  content: var(--tw-content);
  left: -14px;
}
.after\\:-left-\\[22px\\]::after {
  content: var(--tw-content);
  left: -22px;
}
.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}
.after\\:z-40::after {
  content: var(--tw-content);
  z-index: 40;
}
.after\\:block::after {
  content: var(--tw-content);
  display: block;
}
.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}
.after\\:w-\\[6px\\]::after {
  content: var(--tw-content);
  width: 6px;
}
.after\\:bg-\\[\\#FF3E5B\\]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 62 91 / var(--tw-bg-opacity));
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.hover\\:bg-\\[\\#F2F2F2\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#fff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:text-\\[\\#FF3E5B\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 62 91 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:block {
  display: block;
}
@media (min-width: 880px) {

  .slg\\:block {
    display: block;
  }

  .slg\\:transition-none {
    transition-property: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;;EAEE,aAAa;EAKb,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AAPvB;;AAUA;EACE;aACW;AACb;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,yBAAyB;;AAEzB;EACE,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,2DAA2D;AAC7D;;;;;;;;;AASA,yBAAyB;AACzB;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yDAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mEAAmE;EACnE,4BAA4B;EAC5B,gCAAgC;EAChC,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,oEAAoE;EACpE,4BAA4B;EAC5B,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,8EAA8E;EAC9E,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;;;;;AAKvB,mBAAmB;;AAEnB;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;AACpB;;;;;AAKA,iBAAiB;;;AAGjB;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;EACvD,4CAA4C;EAC5C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;EACjD,uDAAuD;EACvD,WAAW;EACX,kBAAkB;AACpB;;;AAGA,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,YAAY;EACZ,OAAO;EACP,MAAM;EACN,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;AACA;EACE;MACI,uBAAuB;EAC3B;;EAEA;MACI,yBAAyB;EAC7B;AACF;AA1WA;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD;AA0WC;AA1WD;EAAA,0BA0WC;EA1WD,kBA0WC;EA1WD;AA0WC;AA1WD;EAAA,gBA0WC;EA1WD;AA0WC;AA1WD;EAAA,kBA0WC;EA1WD;AA0WC;AA1WD;EAAA,kBA0WC;EA1WD;AA0WC;AA1WD;EAAA,oBA0WC;EA1WD;AA0WC;AA1WD;EAAA;AA0WC;AA1WD;;EAAA;IAAA;EA0WC;;EA1WD;IAAA;EA0WC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n  font-family: 'Lato', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.hover\\:bg-white:hover {\n  background-color: transparent !important;\n}\n\n\n#navbars::-webkit-scrollbar,\n#overFlowNone::-webkit-scrollbar {\n  display: none;\n}\n\n#navbars::-webkit-scrollbar,\n#overFlowNone::-webkit-scrollbar {\n  --webkit-scrollbar-width: none;\n  -ms-scrollbar-width: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\ninput:focus-visible,\ninput {\n  border: none;\n  outline: none;\n}\n\nbutton {\n  border: none;\n  outline: none;\n}\n\n#right-to-left {\n  animation: rightToLeft 0.7s linear;\n  right: 5px;\n}\n\n@keyframes rightToLeft {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0%);\n  }\n}\n\n#left-to-right {\n  right: -400px;\n  animation: leftToRight 0.7s linear;\n  transition: right 0.7s ease-in-out !important;\n}\n\n@keyframes leftToRight {\n  from {\n    transform: translateX(0%);\n  }\n\n  to {\n    transform: translateX(100%);\n  }\n}\n\n/* smooth sidebar slide */\n\n#isOpenNavbar {\n  width: 60px;\n  transition: width 0.3s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n}\n\n#isOpenNavbar.isOpenNavbar {\n  width: 282px;\n  transition: width 0.3s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n}\n\n\n\n\n\n\n\n\n/* Start Login Page CSS */\n.parent-div {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-image: url(\"../public/loginbg.svg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n}\n\n.login-button {\n  border: none;\n  outline: none;\n  background: #4f52b2;\n  border-radius: 5.03061px;\n  color: #fff;\n  padding: 10px;\n  font-size: 14px;\n}\n\n.welcome-arrow h3 {\n  color: #2f2f2f;\n  font-weight: 600;\n  font-size: 2rem;\n}\n\n.bottom-img1 {\n  /* background-image: url(\"../../../../../assets/left-cloud.png\"); */\n  background-repeat: no-repeat;\n  background-position: bottom left;\n  height: 19vh;\n  background-size: contain;\n}\n\n.bottom-img2 {\n  /* background-image: url(\"../../../../../assets/right-cloud.png\"); */\n  background-repeat: no-repeat;\n  background-position: bottom right;\n  height: 19vh;\n  background-size: contain;\n}\n\n.links-div {\n  height: 86vh;\n  position: relative;\n  border-bottom: 1px solid #ddd;\n}\n\n.bottom-link {\n  position: absolute;\n  bottom: 0;\n  margin-bottom: 1rem;\n}\n\n.manage-text {\n  color: #9198a0;\n  padding: 0rem 5rem;\n  margin-bottom: 1rem;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.welcome-div {\n  background: #FFFFFF;\n  border: 1px solid rgba(219, 213, 253, 0.4);\n  border-radius: 8px;\n  width: 40%;\n  padding-bottom: 23px;\n  box-shadow: 0px 6px 20px 0px #25242414;\n  transition: all 0.5s ease;\n}\n\n.bottom-cloud {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  height: 10vh;\n  /* background-image: url(\"../../../../../assets/bottom-combined-cloud.png\"); */\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.login-button {\n  border: none;\n  outline: none;\n  background: #4f52b2;\n  border-radius: 5.03061px;\n  color: #fff;\n  padding: 10px;\n  font-size: 14px;\n  padding-right: 30px;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.logClassHome {\n  display: flex;\n  justify-content: center;\n}\n\nimg.img-fluid {\n  display: inline-block;\n}\n\n/* End Login Page CSS */\n\n\n\n\n/* Site Map pages */\n\n.dashboard-parent {\n  display: flex;\n  flex-wrap: wrap;\n  height: calc(100vh - 90px);\n  overflow: auto;\n  padding-left: 12px;\n}\n\n.cards-content-div {\n  width: 100%;\n  /* margin-top: 5rem; */\n  padding: 10px 0px;\n  height: auto;\n  /* border-top: 1.3px solid #e6e6e6; */\n}\n\nh6.title {\n  color: #FF3E5B;\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 5px 8px;\n}\n\np.data {\n  margin: 0;\n  color: #0B0B0C;\n  padding: 5px 8px;\n  font-size: 0.9rem;\n}\n\n.bd-bottom {\n  border-bottom: 1.3px solid #e6e6e6;\n  margin: 20px 10px;\n}\n\n.afterDisable:after {\n  content: none !important;\n}\n\n.catClass {\n  color: #FF3E5B !important ;\n}\n.cat_name_subData{\n  color:  black !important;\n  /* b4/14_regular */\n  font-family: Lato;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 23px; /* 164.286% */\n  padding-left: 10px;\n}\n\n\n\n\n/* Logout popup */\n\n\n.button-div {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-body {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1rem;\n}\n\n.modal-footer {\n  border-top: none !important;\n  justify-content: start !important;\n  flex-wrap: nowrap !important;\n}\n\n.btn-style {\n  border: none;\n  outline: none;\n  background-color: none;\n  padding: 0.5rem;\n  border-radius: 4px;\n}\n\n.no-btn {\n  border-radius: 0.25rem;\n  border: 1px solid var(--lightmode-primary-red, #FF3E5B);\n  color: var(--lightmode-primary-red, #FF3E5B);\n  text-align: center;\n  background-color: #fff;\n}\n\np.logout-text {\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.yes-btn {\n  border-radius: 0.25rem;\n  background: var(--lightmode-primary-red, #FF3E5B);\n  border: 1px solid var(--lightmode-primary-red, #FF3E5B);\n  color: #fff;\n  text-align: center;\n}\n\n\n/* loader css */\n.loader-screen {\n  display: block;\n  position: fixed;\n  display: flex;\n  z-index: 999;\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #FFF;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n.loader-text{\n  width: 30%;\n}\n@keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n\n  100% {\n      transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
